import { render, staticRenderFns } from "./InfoBox.vue?vue&type=template&id=41c4d3fc&scoped=true"
import script from "./InfoBox.vue?vue&type=script&lang=js"
export * from "./InfoBox.vue?vue&type=script&lang=js"
import style0 from "./InfoBox.vue?vue&type=style&index=0&id=41c4d3fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41c4d3fc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VBtn,VCard,VIcon,VMenu})
